import { Icon } from '~/components/ui/Icon';
import { digitsOnly } from '~/lib/masks';

interface SuspendedNoticeProps {
  /** Texto do backend (`OFFICE_SUSPENDED`) ou, antes do envio, o do status do escritório. */
  message: string;
  /** `telefone_suporte` do escritório; vazio esconde a linha. */
  supportPhone: string;
  /** `email_reply_to` do escritório; vazio esconde a linha. */
  supportEmail: string;
}

const INTERNATIONAL_PREFIX = '+';

function phoneHref(phone: string): string {
  const prefix = phone.trim().startsWith(INTERNATIONAL_PREFIX) ? INTERNATIONAL_PREFIX : '';
  return `tel:${prefix}${digitsOnly(phone)}`;
}

/** Aviso de escritório fora de `ACTIVE`, com o contato do próprio escritório quando existe. */
export function SuspendedNotice({
  message,
  supportPhone,
  supportEmail,
}: SuspendedNoticeProps): JSX.Element {
  const hasContact = Boolean(supportPhone || supportEmail);

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        padding: '10px 12px',
        background: 'var(--rx-warn-tint)',
        border: '0.5px solid var(--rx-warn)',
        borderRadius: 10,
      }}
    >
      <Icon name="warn" size={16} color="var(--rx-warn)" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13 }}>
        <span style={{ color: 'var(--rx-text)' }}>{message}</span>
        {hasContact && <span style={{ color: 'var(--rx-text-2)' }}>Contato do escritório:</span>}
        {supportPhone && (
          <a href={phoneHref(supportPhone)} style={{ color: 'var(--rx-text)', fontWeight: 500 }}>
            {supportPhone}
          </a>
        )}
        {supportEmail && (
          <a href={`mailto:${supportEmail}`} style={{ color: 'var(--rx-text)', fontWeight: 500 }}>
            {supportEmail}
          </a>
        )}
      </div>
    </div>
  );
}
